function HomeAboutSection() {
  return (
    <section className="mx-auto w-[min(1120px,calc(100%-40px))] py-7" id="om-oss">
      <div className="mb-6 max-w-[760px]">
        <p className="mb-3.5 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Om OmsorgBygg</p>
        <h2 className="font-serif text-[clamp(2rem,4vw,3.2rem)] font-semibold leading-[1.02] text-[#163127]">
          En erfaren utleier med boliger over hele landet.
        </h2>
      </div>
      <div className="grid gap-5 md:grid-cols-2">
        <p className="text-[1.05rem] leading-[1.7] text-[#355046]">
          OmsorgBygg eier og forvalter boliger og omsorgsbygg flere steder i Norge. Vi legger vekt på god standard,
          forutsigbare leieforhold og tett oppfølging av leietakerne våre.
        </p>
        <p className="text-[1.05rem] leading-[1.7] text-[#355046]">
          På denne siden finner du en oppdatert oversikt over hvilke eiendommer som er ledige, hvor de ligger og når
          de er tilgjengelige. Finner du noe som passer, kan du melde interesse direkte på den enkelte eiendommen.
        </p>
      </div>
    </section>
  );
}

export default HomeAboutSection;